<template>
	<div>
		<div class="u-container">
			<h2 class="page-sub-title mb-4">관리서비스 스탬프 현황</h2>
		</div>
		<AsStampHistoryStatusList />
	</div>
</template>

<script>
import AsStampHistoryStatusList from './AsStampHistoryStatusList';

export default {
	components: {
		AsStampHistoryStatusList,
	},
};
</script>

<style scoped>
.detail-card {
	padding: 0.25rem;
}

.detail-card__content {
	border-radius: 0.1875rem;
	border: 1px solid #c8c8c8;
	background: #fff;
}

.detail-card__content .title {
	display: flex;
	align-items: center;
	height: 3em;
	padding: 0 0.75rem;
	background: #ededed;
	font-size: 0.8125rem;
	font-weight: 300;
}

.detail-card__content .title .complete {
	color: #384ef5;
}

.detail-card__content .title .cancel {
	color: #f53838;
}

.detail-card__content .head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 3em;
	padding: 0 0.75rem;
	border-bottom: 1px solid #c8c8c8;
	font-size: 0.875rem;
	font-weight: 500;
}

.detail-card__content .detail {
	padding: 1rem;
}

.detail-card__content .detail dl {
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
}

.detail-card__content .detail dt,
.detail-card__content .detail dd {
	padding: 0.25em 0;
	font-size: 0.875rem;
	letter-spacing: -0.05em;
}

.detail-card__content .detail dt {
	flex: 0 0 2.5rem;
	color: #666;
	font-weight: 300;
}

.detail-card__content .detail dd {
	flex: 0 0 calc(100% - 2.5rem);
	font-weight: 500;
}

.detail-card__content .detail.is-large dt {
	flex: 0 0 5.625rem;
}

.detail-card__content .detail.is-large dd {
	flex: 0 0 calc(100% - 5.625rem);
}
</style>
